module.exports = __webpack_public_path__ + "assets/iconWarning.9a9325b3.png";